import { store } from '@/store/main';

import featureFlagKeyMap from './feature-flag-keymap';
import { toggleFeatureFlag } from '@/store/slices/feature-flags';
import toastTrigger from '@ui/toast/toast-trigger';
import { EToastTypes } from '@ui/toast/toast.types';

const isProd = import.meta.env.VITE_STAGE === 'prod';

const onoff = (isOn: boolean) => (isOn ? 'on' : 'off');

export class FeatureFlagTool {
  constructor() {
    window.addEventListener('keyup', this.handleKeyUp);
  }

  handleKeyUp = (e: KeyboardEvent) => {
    // must press (alt or option)+shift
    if (e.altKey && e.shiftKey && !isProd) {
      const val = featureFlagKeyMap[e.code];

      if (val) {
        const prevValue = store.getState().featureFlags.featureFlags[val];

        if (typeof prevValue !== 'undefined' || val.startsWith('test')) {
          store.dispatch(toggleFeatureFlag(val));

          toastTrigger('Toggled flag', {
            description: `${val} to ${onoff(!prevValue)}`,
            type: EToastTypes.info,
            closeOnClick: true,
            hideProgressBar: false,
          });
        }
      }
    }
  };
}
